import React from "react";
import { EuiEmptyPrompt } from "@elastic/eui";

export default function ({ title, body }) {
    return (
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>{title}</h2>}
            body={<p>{body}</p>}
        />
    );
}
